import React, { useMemo } from 'react';

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue, cn } from '@column/ui';

import { Access } from '../types';

import {
  AccessIconCustom,
  AccessIconDefault,
  AccessIconFullAccess,
  AccessIconNoAccess,
  AccessIconViewOnly,
} from './AccessIcons';

interface Props {
  'aria-label'?: string;
  className?: string;
  onChange: (value: Access) => void;
  showDefault?: boolean;
  value: Access;
  variant?: 'default' | 'card';
}

const iconClassName = '[--icon-size-x:16px] [--icon-size-y:16px]';

export const AccessDropdown: React.FC<Props> = ({
  'aria-label': ariaLabel,
  className,
  onChange,
  showDefault,
  value,
  variant,
}) => {
  const options = useMemo(
    () => [
      ...(showDefault
        ? [{ label: 'Default', icon: <AccessIconDefault className={iconClassName} />, value: Access.Default }]
        : []),
      { label: 'No Access', icon: <AccessIconNoAccess className={iconClassName} />, value: Access.NoAccess },
      { label: 'View Only', icon: <AccessIconViewOnly className={iconClassName} />, value: Access.ViewOnly },
      { label: 'Full Access', icon: <AccessIconFullAccess className={iconClassName} />, value: Access.FullAccess },
      { label: 'Custom', icon: <AccessIconCustom className={iconClassName} />, value: Access.Custom },
    ],
    [showDefault]
  );

  return (
    <Select value={value} onValueChange={(newValue) => onChange(newValue as Access)}>
      <SelectTrigger size="sm" variant={variant} aria-label={ariaLabel} className={cn('w-full', className)}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent position="popper" align="end">
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.icon}
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
